import * as MoneySum from "./MoneySum";
import { capitalize } from "lodash";
export { capitalize };

Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

export function encodeURIParams(params) {
  return Object.keys(params)
    .map((k) => {
      const v = params[k];
      return v !== undefined && v !== null ? `${encodeURIComponent(k)}=${encodeURIComponent(v)}` : null;
    })
    .filter((v) => v !== null)
    .join("&");
}

export function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

export function normalizePositions(elements) {
  return elements.map((el, i) => ({ ...el, position: i + 1 }));
}

export const domUtils = {
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },

  isElementFullyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },
};

export function formatMoney(amount, transactionAmount = null) {
  if (amount == null) {
    return;
  }
  if (
    transactionAmount &&
    !MoneySum.isEqual(
      Array.isArray(amount) ? amount : [amount],
      Array.isArray(transactionAmount) ? transactionAmount : [transactionAmount]
    )
  ) {
    const am = formatMoney(amount);
    const tAm = formatMoney(transactionAmount);
    return tAm ? `${am} (${tAm})` : am;
  }
  if (amount.length != null) {
    return MoneySum.sort(amount)
      .map((a) => formatMoney(a))
      .join(" + ");
  }

  let { value, currency } = amount;
  value = Math.round(value * 100) / 100;
  const sign = value >= 0 ? "" : "-";
  const units = ~~Math.abs(value);
  let cents = Math.round(100 * Math.abs(value)) % 100;
  if (0 < cents && cents < 10) {
    cents = `0${cents}`;
  }
  const number = cents > 0 ? `${units},${cents}` : units;

  let currencySymbol = currency;
  if (currency === "PLN" && I18n.locale === "pl") {
    currencySymbol = "zł";
  }
  if (currency === "USD") {
    currencySymbol = "$";
  }
  if (currency === "EUR") {
    currencySymbol = "€";
  }
  return `${sign}${number} ${currencySymbol}`;
}

export function formatPercentage(percentage) {
  if (percentage === null) {
    return;
  }
  return `${percentage}%`;
}

export function formatDateRange(startDate, endDate, { format } = {}) {
  return _([startDate, endDate])
    .compact()
    .map((date) => formatDate(date, { format }))
    .uniq()
    .value()
    .join(" - ");
}

export function formatTimeRange(startsAt, endsAt, { includeTime = true, includeDate = true, format = "long" } = {}) {
  if (!startsAt && !endsAt) {
    return null;
  }

  if (!endsAt) {
    return `${capitalize(I18n.t("base.from"))} ${formatTime(startsAt, {
      includeTime,
    })}`;
  }

  if (!startsAt) {
    return `${capitalize(I18n.t("base.to"))} ${formatTime(endsAt, {
      includeTime,
      format,
    })}`;
  }

  if (!includeTime) {
    return formatDateRange(startsAt, endsAt);
  }

  if (!includeDate || formatDate(startsAt, { format: "short" }) === formatDate(endsAt, { format: "short" })) {
    const time = _([startsAt, endsAt])
      .map((time) => formatTime(time, { format: "time" }))
      .uniq()
      .value()
      .join(" - ");

    return includeDate ? [formatDateRange(startsAt, endsAt), time].join(" ") : time;
  }

  return _([startsAt, endsAt])
    .uniq()
    .map((time) => formatTime(time, { format }))
    .value()
    .join(" - ");
}

export function formatTimeDuration(timeDuration) {
  return moment.duration(timeDuration * 1000).humanize();
}

export function roundPrice(value) {
  if (!value || value <= 0) {
    return value;
  }
  return Math.round(value * 100) / 100;
}

export function formatTime(date, options = {}) {
  const { format = "long", includeTime = true, localZone = false } = options;

  if (!includeTime) {
    return formatDate(date, options);
  }

  const m = localZone || date.length <= 10 ? moment : moment.parseZone;
  switch (format) {
    case "long":
      return capitalize(m(date).format("dddd, D MMMM YYYY [o] HH:mm"));
    case "medium":
      return capitalize(m(date).format("D MMMM YYYY [o] HH:mm"));
    case "short":
      return _.capitalize(m(date).format("DD-MM-YYYY HH:mm"));
    case "time":
      return capitalize(m(date).format(moment.TIME_FORMAT));
    default:
      return capitalize(m(date).format(format));
  }
}

export function formatDate(date, options = {}) {
  const { format = "long", localZone = false } = options;

  const m = localZone || date.length <= 10 ? moment : moment.parseZone;
  switch (format) {
    case "long":
      return capitalize(m(date).format("dddd, D MMMM YYYY"));
    case "short":
      return capitalize(m(date).format("DD-MM-YYYY"));
    default: {
      return capitalize(m(date).format("D MMMM YYYY"));
    }
  }
}

export function generateUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function range(left, right, inclusive = false) {
  if (Math.abs(right - left) > 100000) {
    throw new Error("left - right is bigger than 100000, aborting");
  }
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}

export function guard(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

export function getAttachmentImageUrl(object, name, version, defaultUrl = "/images/placeholder-image.png") {
  const file = object && ((object[name] && object[name].file) || object[`${name}_file`]);
  return (file && (file[version] ? file[version].url : file.url)) || defaultUrl;
}

export function addQueryParamsToUrl(url, params = {}) {
  const encodedParams = encodeURIParams(params);
  if (encodedParams) {
    const [urlWithoutAnchor, anchor] = url.split("#");
    if (urlWithoutAnchor.indexOf("?") !== -1) {
      url = `${urlWithoutAnchor}&${encodedParams}${anchor ? "#" + anchor : ""}`;
    } else {
      url = `${urlWithoutAnchor}?${encodedParams}${anchor ? "#" + anchor : ""}`;
    }
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/lib/utils/socialtravel.js